// extracted by mini-css-extract-plugin
module.exports = {"card":"VitrinsOffersCard_card__LmDH6","grayCard":"VitrinsOffersCard_grayCard__ofcp8","logo":"VitrinsOffersCard_logo__cGpTB"};